export const SET_BOT_VARS  = "SET_BOT_VAR";
export const GET_BOT_VARS  = "GET_BOT_VARS";

export const SET_LABELS = "SET_LABELS";
export const GET_LABELS = "GET_LABELS";


export const SET_SEQUENCE = "SET_SEQUENCE";
export const GET_SEQUENCE = "GET_SEQUENCE";
export const RESET_BOTVARS= "RESET_BOTVARS";



